module.exports = __webpack_public_path__ + "img/3_5.9a19800a.png";